import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, formatINR } from "../lib/api";
import { Check } from "lucide-react";
import { motion } from "framer-motion";

export default function OrderConfirmation() {
  const { orderNumber } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/orders/${orderNumber}`).then((r) => setOrder(r.data)).catch(() => setOrder(null));
  }, [orderNumber]);

  return (
    <main data-testid="order-confirmation-page" className="bg-[#0A0A0A] min-h-screen pt-[120px] pb-24">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <motion.div
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="w-20 h-20 rounded-full mx-auto bg-[#D4AF37] flex items-center justify-center"
        >
          <Check size={32} strokeWidth={1.75} className="text-[#0A0A0A]" />
        </motion.div>
        <div className="text-[11px] tracking-[0.45em] uppercase text-[#D4AF37] mt-8 mb-3">
          ✦ Order Confirmed
        </div>
        <h1 className="font-serif-display text-5xl md:text-7xl tracking-tighter">
          It's <em className="not-italic gold-text">yours.</em>
        </h1>
        <p className="text-[#A3A3A3] mt-5 text-sm">
          A confirmation has been sent to your email. Your box is on its way.
        </p>

        {order && (
          <div className="mt-12 bg-[#141414] border border-[#262626] p-8 text-left" data-testid="order-summary">
            <div className="flex justify-between items-center pb-4 border-b border-[#262626]">
              <span className="text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3]">Order</span>
              <span className="font-serif-display text-xl text-[#D4AF37]">#{order.order_number}</span>
            </div>
            <div className="space-y-3 mt-5">
              {order.items.map((it) => (
                <div key={it.product_id} className="flex justify-between text-sm">
                  <span>{it.name} x{it.quantity}</span>
                  <span>{formatINR(it.price * it.quantity)}</span>
                </div>
              ))}
            </div>
            <div className="border-t border-[#262626] mt-5 pt-4 flex justify-between font-serif-display text-2xl">
              <span>Total</span>
              <span>{formatINR(order.total)}</span>
            </div>
            <div className="mt-4 text-xs text-[#A3A3A3] tracking-[0.2em] uppercase">
              Payment: {order.payment_method === "cod" ? "Cash on Delivery" : "Razorpay (MOCKED)"}
            </div>
          </div>
        )}

        <Link to="/shop" className="btn-gold mt-10 inline-flex" data-testid="continue-shopping-btn">
          Continue Shopping
        </Link>
      </div>
    </main>
  );
}
